// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { post,upload } from './utils/request'
Vue.config.productionTip = false;
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll);
import vSelect from 'vue-select'
Vue.component('v-select', vSelect);
/* eslint-disable no-new */
var vm=new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  methods: {
  test(){
 
  }
  }
});
Vue.prototype.test = vm.test;



// WEBPACK FOOTER //
// ./src/main.js